'use strict';

export default [
    '$utils',
    function ($utils) {
        return {
            sortProjectMaintenancesByNpp,
            nppSort,
        };

        function sortProjectMaintenancesByNpp(items) {
            let sortedItems = [];

            let roots = items.filter((item) => item.parent == null)
                .sort(nppSort);

            roots.forEach((item) => {
                sortedItems.push(item);
                if (item.isGroup) {
                    let childs = items.filter((it) => it.parentIndex == item.index)
                        .sort(nppSort);
                    sortedItems = sortedItems.concat(childs);
                }
            });

            return sortedItems;
        }

        function nppSort(a, b) {
            let result = $utils.numComparator(a.npp, b.npp);
            if (result !== 0) {
                return result;
            }

            return $utils.stringComparator(a.activityName, b.activityName);
        }
    }];
